import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const noApi = AiseaApiFactory.get("notification");

export default {
  setNotificationSearchQuery({ commit }, query) {
    commit("SET_NOTIFICATION_SEARCH_QUERY", query);
  },
  async fetchAllNotifications({ commit }) {
    let payload = {
      limit: 999,
      start: 0
    };
    const notificationRes = await noApi.fetchNotifications(payload);
    commit("SET_NOTIFICATIONS", {
      notifications: notificationRes.data.notifications,
      pageable: notificationRes.data.pageable
    });

    return true;
  },
  async fetchUnreadNotifications({ commit }) {
    let payload = {
      is_already_read: false,
      limit: 999,
      start: 0
    };
    const unreadNotificationRes = await noApi.fetchNotifications(payload);
    commit("SET_UNREAD_NOTIFICATIONS", {
      unreadNotifications: unreadNotificationRes.data.notifications,
      pageable: unreadNotificationRes.data.pageable,
      unreadCount: unreadNotificationRes.data.count
    });

    return unreadNotificationRes.data.count
  },
  // eslint-disable-next-line no-unused-vars
  async readeNotifications({ state }, notificationId) {
    await noApi.read(notificationId);
    return true;
  },
  async readeAllNotifications({ state }) {
    let unreadNotifications = state.unreadNotifications.slice();
    const resultPromise = [];
    unreadNotifications.forEach(unreadNotification => {
      resultPromise.push(noApi.read(unreadNotification.id));
    });
    await Promise.all(resultPromise);
    return true;
  },
};
